module.exports = __webpack_public_path__ + "static/media/CNews2.9b4a2d43.png";